
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.38 10.967l.61 4.24a1.141 1.141 0 01-1.131 1.293h-.169l-4.235-.61a2.655 2.655 0 01-1.516-.755l-7.813-7.83a4.019 4.019 0 01.049-5.629 4.007 4.007 0 015.622-.049l7.83 7.822c.41.41.674.943.753 1.518zm-5.55 3.316c.221.214.5.359.801.418l4.18.554-.586-4.152a1.606 1.606 0 00-.417-.803L5.987 2.478a2.798 2.798 0 00-4.01 0 2.804 2.804 0 000 3.976l7.852 7.83z","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M4.359 4.012a.601.601 0 00-.85.852l3.376 3.38a.601.601 0 10.85-.85L4.36 4.011z","fill":"#7B01B5"}})])
          )
        }
      }
    